<template>
  <div class="space-y-4">
    <div v-for="invoice in invoices" :key="invoice.id">
      <div class="bg-white rounded-2xl shadow-md p-4">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-bold text-gray-900">Facture #{{ invoice.id }}</h3>
          <span
            :class="[
              'inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium',
              invoiceStatusClass(invoice.approvalStatus),
            ]"
          >
            {{ $t(`claim_invoice.status.${invoice.approvalStatus}`) }}
          </span>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
          <StackedField label="Fichier">
            <div class="inline-flex items-center bg-white rounded-sm p-2 border border-gray-200">
              <PaperClipIcon class="shrink-0 h-3 w-3 text-gray-400 mr-1" />
              <span class="text-xs text-gray-900 mr-2 max-w-xs truncate">{{ invoice.fileName }}</span>
              <a
                :href="invoice.url"
                target="_blank"
                rel="noopener noreferrer"
                class="shrink-0 p-1 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-sm transition-colors duration-200"
              >
                <EyeIcon class="h-3 w-3" />
              </a>
            </div>
          </StackedField>
          <StackedField label="Montant" :value="formatPrice(invoice.repairCost)" />
        </div>
        <InvoiceCostDetails :invoice="invoice" class="mt-4" />
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";
import { EyeIcon, PaperClipIcon } from "@heroicons/vue/solid";
import InvoiceCostDetails from "@/components/claim/details/invoice/InvoiceCostDetails.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    invoices: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    StackedField,
    InvoiceCostDetails,
    PaperClipIcon,
    EyeIcon,
  },

  computed: {
    ...mapGetters("claimInvoices", ["invoiceStatusClass"]),
  },

  methods: {
    formatPrice,
  },
};
</script>
